import React from 'react';
var BoolCell = function (_a) {
    var value = _a.value;
    switch (value) {
        case true:
            return React.createElement("span", null, "Yes");
        case false:
            return React.createElement("span", null, "No");
        default:
            return React.createElement("span", null);
    }
};
export default BoolCell;
//# sourceMappingURL=BoolCell.js.map